// extracted by mini-css-extract-plugin
export default {"item":"OrderXu_item__UiKXk"};